var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menuVertical fechado" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _c("ul", { staticClass: "itensPai" }, [
      _c(
        "li",
        {
          attrs: { title: "Regras de orçamento" },
          on: {
            click: function($event) {
              return _vm.goToRules()
            }
          }
        },
        [_vm._m(3)]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          attrs: { title: "Orçamentos" },
          on: {
            click: function($event) {
              return _vm.goToBudgets()
            }
          }
        },
        [_vm._m(4)]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticStyle: { cursor: "default", opacity: "0.6" },
          attrs: { title: "Editar Email" },
          on: {
            click: function($event) {
              return _vm.goToBudgetsEditEmail()
            }
          }
        },
        [_vm._m(5)]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticStyle: { cursor: "default", opacity: "0.6" },
          attrs: { title: "Editar Formulário" },
          on: {
            click: function($event) {
              return _vm.goToBudgetEditInfo()
            }
          }
        },
        [_vm._m(6)]
      ),
      _vm._v(" "),
      _c("li", { attrs: { title: "Sair" } }, [
        _c("a", { staticClass: "menu sair", attrs: { href: "#" } }, [
          _c("i", {
            staticClass: "fas fa-sign-out-alt",
            on: {
              click: function($event) {
                return _vm.logout()
              }
            }
          }),
          _c("span", [_vm._v("Sair")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "version-informarion" }, [
      _vm._v("v" + _vm._s(_vm.version))
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "openMenu" }, [
      _c("div", [
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "closeMenu", attrs: { type: "button" } },
      [_c("i", { staticClass: "fas fa-outdent" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "perfilUsuario" }, [
      _c("img", {
        attrs: { src: "/static/resources/images/perfil.png", alt: "Usuário" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "menu cadastros", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fas fa-clipboard-list" }),
      _vm._v(" "),
      _c("span", [_vm._v("Regras de orçamento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "menu cadastros", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fas fa-dollar-sign" }),
      _vm._v(" "),
      _c("span", [_vm._v("Orçamentos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "menu cadastros", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fa fa-envelope" }),
      _vm._v(" "),
      _c("span", [_vm._v("Edição de Email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "menu cadastros", attrs: { href: "#" } }, [
      _c("i", { staticClass: "fa fa-text-width" }),
      _vm._v(" "),
      _c("span", [_vm._v("Editar Fomulário")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d37a4ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d37a4ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav/Toolbar.vue
// module id = null
// module chunks = 